import { render, staticRenderFns } from "./highSeas-info.pug?vue&type=template&id=19b50b77&lang=pug&"
import script from "./highSeas-info.ts?vue&type=script&lang=ts&"
export * from "./highSeas-info.ts?vue&type=script&lang=ts&"
import style0 from "./highSeas-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports